import { render } from "./logisticareversa.vue?vue&type=template&id=7c1ef0d0&scoped=true"
import script from "./logisticareversa.vue?vue&type=script&lang=js"
export * from "./logisticareversa.vue?vue&type=script&lang=js"

import "./logisticareversa.vue?vue&type=style&index=0&id=7c1ef0d0&scoped=true&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1ef0d0"]])

export default __exports__